import { faSearch } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import {
  SEARCH_PLACEHOLDER,
  SEARCH_BUTTON_ARIA_LABEL,
} from '../../config/text/text';
import Icon from '../Icon';

const HeaderSearch = () => {
  return (
    <>
      <div className="col-md order-md-1">
        <form className="search-container">
          <input
            aria-controls="search-suggestions"
            aria-expanded={false}
            aria-haspopup="listbox"
            aria-label={'Search Wowcher Website'}
            autoComplete="off"
            className="input"
            data-qa="enterSearch"
            data-testid="search-input"
            id="header-search"
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                event.preventDefault();
                window.location.href = `${process.env.NEXT_PUBLIC_BASE_ROOT_URL}/search?q=${event.target.value}`;
              }
            }}
            placeholder={SEARCH_PLACEHOLDER}
            role="combobox"
            type="text"
          />
          <button
            aria-label={SEARCH_BUTTON_ARIA_LABEL}
            className="search-button search-input__submit-button"
            data-testid="search-submit-button"
            onClick={() => {
              window.location.href = `${process.env.NEXT_PUBLIC_BASE_ROOT_URL}/search?q=`;
            }}
            type="button"
          >
            <Icon color="none" faIcon={faSearch} size="19px" />
          </button>
        </form>
      </div>

      <style jsx>{`
        .search-input__submit-button:disabled {
          cursor: not-allowed;
        }
        .search-container {
          display: block;
          margin-top: 2px;
          position: relative;
        }
        .search-button {
          background-color: transparent;
          border: 0;
          border-radius: 0 20px 20px 0;
          color: #eb008c;
          height: 31px;
          position: absolute;
          right: 1px;
          top: 1px;
          width: 38px;
        }
        .input {
          background-color: rgb(255, 235, 247);
          border-color: rgb(235, 0, 140);
          border-width: 1px;
          border-style: solid;
          border-radius: 20px;
          color: rgb(0, 0, 0);
          height: 33px;
          margin-bottom: 6px;
          padding: 0 45px 0 8px;
          width: 100%;
        }
        .input::placeholder {
          font-size: 12px;
          color: #aaaaaa;
        }
        .input:focus {
          border-color: #000000;
          background-color: #ffffff;
          outline: none;
        }
        .search-button:focus {
          background-color: '#000000';
          color: #ffffff;
        }
        .input:focus ~ .search-button {
          background-color: '#000000';
          color: #ffffff;
        }
        .search-button:focus ~ .input {
          border-color: #000000;
          background-color: #ffffff;
          outline: none;
        }
        @media (min-width: 768px) {
          .search-button {
            height: 38px;
            width: 38px;
          }
          .input {
            height: 40px;
            margin-bottom: 0;
          }
          .input::placeholder {
            font-size: 14px;
          }
        }
      `}</style>
    </>
  );
};

export default HeaderSearch;
